import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import { LinkButton } from "components/buttons";
import epayment_1 from "assets/images/epayment_table1.svg";
import epayment_2 from "assets/images/epayment_table2.svg";
import epayment_3 from "assets/images/epayment_table3.svg";
import epayment_4 from "assets/images/epayment_table4.svg";
import epayment_5 from "assets/images/epayment_table5.svg";
import epayment_6 from "assets/images/epayment_table6.svg";

function EPayment() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Cash Management"
          title={`
           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
             e-<span className="jumbotron-subtitle-2">Payment</span>
            </div>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              For more information on e-Payment services and Fees, please click 
              <a
                href="https://www.bnm.gov.my/e-payment-services-and-fees?inheritRedirect=true"
                target="blank"
              >
                here
              </a>
              .
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Intrabank Funds Transfer</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={epayment_1}
              className="d-inline-block align-top"
              alt=""
            />
            <p>
              *For manufacturing sector, sales turnover not exceeding RM50 mil
              or full-time employees not exceeding 200 workers; for services and
              other sectors, sales turnover not exceeding RM20 mil or full-time
              employees not exceeding 75 workers 
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Interbank GIRO (IBG)</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={epayment_2}
              className="d-inline-block align-top"
              alt=""
            />
            <p>
              *For manufacturing sector, sales turnover not exceeding RM50 mil
              or full-time employees not exceeding 200 workers; for services and
              other sectors, sales turnover not exceeding RM20 mil or full-time
              employees not exceeding 75 workers
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>DuitNow Fund Transfer</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={epayment_3}
              className="d-inline-block align-top"
              alt=""
            />
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Rentas</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={epayment_4}
              className="d-inline-block align-top"
              alt=""
            />
            <p>
              *For manufacturing sector, sales turnover not exceeding RM50 mil
              or full-time employees not exceeding 200 workers; for services and
              other sectors, sales turnover not exceeding RM20 mil or full-time
              employees not exceeding 75 workers
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Cross Border Fund Transfer (CBTF)</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={epayment_5}
              className="d-inline-block align-top"
              alt=""
            />
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>
              Other related fees/ charges for Online Banking (Corporate Internet
              Banking) Cash Management Service
            </h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={epayment_6}
              className="d-inline-block align-top"
              alt=""
            />
            <p>
              *For manufacturing sector, sales turnover not exceeding RM50 mil
              or full-time employees not exceeding 200 workers; for services and
              other sectors, sales turnover not exceeding RM20 mil or full-time
              employees not exceeding 75 workers.
            </p>
            <div className="link-button-row" style={{ paddingTop: "100px" }}>
              <LinkButton
                text="Terms and Conditions (NAD)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/epayment/NAD_Terms%20%20Conditions.pdf"
                  )
                }
              />
              <LinkButton
                text="Terms and Conditions (DuitNow)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/epayment/DuitNow_TNC.pdf"
                  )
                }
              />
              <LinkButton
                text="Frequently Asked Questions - DuitNow Transfer"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/epayment/FAQs_DuitNow%20Transfer%202022.pdf"
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default EPayment;
